export const button = () => {
    let sfLinks = document.querySelectorAll(".sf-link");
    if (sfLinks) {
        sfLinks.forEach((el) => {
            el.addEventListener("click", function () {
                let sfLink = el.dataset.sfA;
                let prevent = parseInt(el.dataset.prevent);

                if(prevent > 0) return;

                if (sfLink) {
                    try {
                        let decodedLink = atob(sfLink);
                        document.location.href = decodedLink;
                    } catch (e) {
                        console.error("Failed to decode Base64 string:", e);
                    }
                }
            });
        });
    }
};

button();


let buttonLinks = document.querySelectorAll('._button-link');
if (buttonLinks) {
    buttonLinks.forEach((el) => {
        el.addEventListener('click', function () {
            let link = el.dataset.sfA;
            link ? document.location.href = link : null
        });
    });
}
